<app-autocomplete (autocompleteInput)="onTimezoneChange($event)" (selection)="onTimezoneSelected($event)"
                  [defaultValue]="defaultId" [disabled]="disabled" [doAutofocus]="false" [clearInputOnSelect]="false"
                  [hint]="'Search timezone by name or GMT offset'" [objects]="timezones"
                  [options]="autocompleteTimezones" [searchName]="'Timezones'"
></app-autocomplete>
